<template>
  <WorkOrderDetails/>
</template>
<script>
import WorkOrderDetails from 'operations/workorder/workOrderDetails.vue'
export default {
    components:{
      WorkOrderDetails
    }
}
</script>